import React from 'react';
import { Box, Button, Text } from '@wix/design-system';
import { useModalystInstall } from '../hooks';
import { generateToken } from '../utils';
const referral = 'wix-aichat';
const action = 'connect_modalyst';
export const ModalystInstaller = _ref => {
  let {
    data: {
      metaSiteId
    },
    context: {
      onWidgetAction,
      send
    }
  } = _ref;
  const {
    startInstall
  } = useModalystInstall({
    referral
  });
  const handleInstallClick = () => {
    const modalystToken = generateToken(10);
    onWidgetAction(MODALYST_INSTALLER, {
      action
    });
    send('Install Modalyst app on my site and connect it to a Modalyst store');
    startInstall({
      metaSiteId,
      modalystToken
    });
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, "Clicking the button below will install the Modalyst app on your Wix site, ensure a Modalyst account is created for you and connect your site to Modalyst."), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    priority: "secondary",
    onClick: handleInstallClick,
    fullWidth: true
  }, "Connect Modalyst to my site"));
};
export const MODALYST_INSTALLER = 'MODALYST_INSTALLER';
//# sourceMappingURL=ModalystInstaller.js.map